import './style.scss';

export default () => {
  return `
       <div class="content-article">
        <div class="content-article-arrow"></div>
        <div class="content-article-text">
          <p>请点击右上角用</p>
          <p>发送给朋友</p>
          <p>或</p>
          <p>分享到朋友圈</p>
        </div>
      </div>
  `;
};
